import * as React from "react";
import { Button,ButtonGroup,  Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap";
import { IDownloadProps, IDownloadPropsFunctions } from "../props/IDownloadProps";
import IJobCalculation from "../interfaces/IJobCalculation";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglassStart, faSpinner, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { calculationStatusIcons, calculationStatusNames } from "../../../settings";
import IMainState from '../../../IMainState';
library.add(faHourglassStart, faSpinner, faCheck, faTimes);

type IProps = IDownloadProps & IDownloadPropsFunctions;


class DownloadComponent extends React.Component<IProps> {

    downloadData = () => {
        this.props.downloadData(this.props.jobId);
    }

    render() {
        return <div className="mutantComponent">
             <ButtonGroup variant="outlined" aria-label="outlined primary button group" style={{ width: "100%",}}>
                <Button onClick={this.downloadData} style={{borderColor: "black", margin: 0}}>
                    Download data
                </Button>
            </ButtonGroup>
    </div>
    }
    
}

export default DownloadComponent;
